import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          FindMyScheme is not affiliated with the government; eligibility results are indicative—please verify details on official portals.
        </p>
      </div>
    </footer>
  );
}
